import {
    Button as MuiButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    CircularProgress
} from '@mui/material';
import { useNotify, useRefresh, useRecordContext } from 'react-admin';
import { useState } from 'react';

import { useSubmitData } from '../../../../../hooks/useSubmitData';
import { clearAccountData } from '../../../../../api';

import { PLATFORMS } from '../../../../../config/constants/reportConstants';

export const ClearAccountDataButton = () => {
    const [open, setOpen] = useState(false);
    const notify = useNotify();
    const refresh = useRefresh();
    const record = useRecordContext();
    const { submit, loading } = useSubmitData(clearAccountData);

    if (!record) return null;

    const handleClick = () => {
        setOpen(true);
    };

    const handleClose = () => {
        if (!loading) setOpen(false);
    };

    const handleConfirm = async () => {
        try {
            const { result } = await submit(record);
            const rowsMessage = result.rowCount ?
                `Account data cleared successfully. ${result.rowCount} rows were deleted` : 'No relevant records were found';
            notify(
                rowsMessage,
                { type: 'info' }
            );
            refresh();
        } catch {
            notify('Failed to clear account data', { type: 'error' });
        } finally {
            setOpen(false);
        }
    };

    return (
        <>
            <MuiButton onClick={handleClick} variant="contained" color="error" sx={{ mt: 2 }}>
                Clear All Account Data
            </MuiButton>

            <Dialog open={open} onClose={handleClose}>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this account’s data{record.platform === PLATFORMS.META ? ` (account ID - ${record.account_id})` : ''}?
                        <br />
                        If you proceed, all data associated with this account will be permanently erased.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center' }}>
                    {!loading ? (
                        <>
                            <MuiButton
                                onClick={handleConfirm}
                                color="primary"
                                disabled={loading}
                            >
                                Proceed
                            </MuiButton>
                            <MuiButton
                                onClick={handleClose}
                                color="primary"
                                disabled={loading}
                            >
                                Cancel
                            </MuiButton>
                        </>
                    ) : (
                        <CircularProgress size={24} sx={{ m: '0 auto' }} />
                    )}
                </DialogActions>
            </Dialog>
        </>
    );
};